module.exports = __webpack_public_path__ + "static/media/youyu.aea51c1a.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/youyu.png
 ** module id = 483
 ** module chunks = 0
 **/